import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function VideoSection() {
  return <section className="bg-brand-black-light border-y border-white/10 py-10 px-4" data-id="element-482">
      <div className="max-w-[700px] mx-auto" data-id="element-483">
        <div className="text-center mb-6" data-id="element-484">
          <h2 className="text-[24px] font-bold text-brand-black mb-2 flex items-center justify-center gap-2" data-id="element-485">
            <PlayCircleIcon className="w-6 h-6 text-primary" data-id="element-486" />
            Mira Cómo Funciona el Sistema
          </h2>
          <p className="text-dark-gray text-sm" data-id="element-487">
            Descubre en 2 minutos cómo esta guía puede transformar tu carrera
            como electricista
          </p>
        </div>

        {/* Video */}
        <div className="mx-auto overflow-hidden shadow-2xl rounded-xl border border-white/10 bg-black" data-id="element-488">
          <video autoPlay loop muted playsInline preload="none" className="w-full h-auto block" data-id="element-489">
            <source src="https://cdn.magicpatterns.com/uploads/e3fJCnG9w2mKAgsypQS38r/2dO6p5E.mp4" type="video/mp4" data-id="element-490" />
          </video>
        </div>
      </div>
    </section>;
}